import { Component, TemplateRef, ChangeDetectionStrategy, inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogActions } from "@angular/material/dialog";
import { DialogService } from "../../services/dialog.service";
import { MatIcon } from "@angular/material/icon";
import { NgTemplateOutlet } from "@angular/common";

@Component({
  selector: "app-dialog",
  templateUrl: "./dialog.component.html",
  styleUrls: ["./dialog.component.less"],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatDialogActions, MatIcon, NgTemplateOutlet],
})
export class DialogComponent {
  readonly dialogService = inject(DialogService);

  public templateRef: TemplateRef<unknown>;
  public data: unknown;
  public dialogRef: MatDialogRef<unknown>;

  public constructor() {
    const data = inject(MAT_DIALOG_DATA);
    const dialogRef = inject<MatDialogRef<unknown>>(MatDialogRef);

    this.templateRef = data.template;
    this.data = data.data;
    this.dialogRef = dialogRef;
  }

  public closeDialog() {
    this.dialogService.close();
  }
}
